module.exports = __webpack_public_path__ + "img/umb40_uv_sleeve.cb240c7b.svg";